"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var groupTypes_exports = {};
__export(groupTypes_exports, {
  swipeActionsEdges: () => swipeActionsEdges,
  viewThatFitsAxes: () => viewThatFitsAxes
});
module.exports = __toCommonJS(groupTypes_exports);
var swipeActionsEdges = [
  "leading",
  "trailing"
];
var viewThatFitsAxes = [
  "horizontal",
  "vertical",
  "both"
];
//# sourceMappingURL=groupTypes.js.map
